/* ============================================================
   ZAGARA LUXURY — Main JS
   Lenis · GSAP · Cursor · Cart · Animations
   ============================================================ */

/* Nome e sottotitolo di un prodotto: SPECCHIO di snippets/zg-product-title.liquid
   (prima occorrenza di un trattino con almeno uno spazio dopo). UNICA copia
   JS, esposta prima di tutto: la leggono lux-search.js (tile e suggerimenti) e
   lux-cart.js (cassetto e tendina), che caricano dopo questo file. Chi cambia
   il Liquid cambia anche questa. */
(function () {
  window.ZAGARA = window.ZAGARA || {};
  var RE = /\s*[-\u2013\u2014]\s+/;
  window.ZAGARA.splitTitle = function (full) {
    var s = String(full || '');
    var m = RE.exec(s);
    if (!m || m.index === 0) return { name: s.trim(), sub: '' };
    return { name: s.slice(0, m.index).trim(), sub: s.slice(m.index + m[0].length).trim() };
  };
  /* La soglia della testata del telefono (giro finale, tappa 2, voce t2-soglia; decisione 3, mappa3 §3.4): UNA media query
     per tutto il JS che deve sapere quale testata si vede. Fino a 1151.98 px la testata del telefono (.header-inner--m, il
     menu a pannello: luxury.css, il blocco a 1151.98), da 1152 la barra del computer. Esposta qui, prima di tutto, come
     splitTitle: la leggono il menu del telefono e la tendina «Shop» (qui sotto: si chiudono passandola), lux-wishlist.js
     (sotto: il foglio dal basso col velo; sopra: il pannello ancorato all'icona) e lux-cart.js (sotto: l'icona apre /cart;
     sopra: la tendina ancorata all'icona), che si caricano dopo questo file (theme.liquid, defer in ordine). Prima ognuno
     aveva la sua (innerWidth <= 767, matchMedia 767.98). Lo stesso numero e' nel CSS: luxury.css e lux-wishlist.css. */
  /* Voce menu-trade (strada 1 di Giacomo, 11/10/2026 sera): in italiano e in spagnolo la barra con «Trade» sta solo da 1280 px,
     quindi la testata del telefono arriva a 1279.98 (luxury.css e lux-wishlist.css, i blocchi a 1152-1279.98). La lingua e'
     quella della pagina (<html lang>, scritta dal server); le altre cinque restano a 1151.98. */
  window.ZAGARA.testataTelefono = window.matchMedia(/^(it|es)\b/i.test(document.documentElement.lang || '') ? '(max-width: 1279.98px)' : '(max-width: 1151.98px)');
  /* Giro finale, tappa 2, voce t2-barra-via (decisione 6, mappa3 §4.3, foglio 04 §1.2): la barra in basso di lux-sticky-tools
     non c'e' piu', e la sua X lasciava zagara_sbar_dismissed in sessionStorage. Qui, su ogni pagina, la chiave si toglie. Vive
     per scheda e per sessione: basta un rilascio, poi questa riga si toglie (lista della pulizia). Il try: sessionStorage
     puo' lanciare (archiviazione bloccata). zag_loaded (il velo d'ingresso, theme.liquid) non e' della barra e resta. */
  try { window.sessionStorage.removeItem('zagara_sbar_dismissed'); } catch (e) {}
})();

(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
  }

  const lib = { gsap: false, st: false, lenis: false };

  // GSAP tweens bypass the CSS reduced-motion kill-switch (they write inline
  // styles), so every entrance/scrub animation must check this flag itself.
  const ZG_REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Shared behavior for programmatic scrolls: explicit behavior options
  // ignore the CSS scroll-behavior reset, so each scrollTo/scrollBy call
  // site must ask this helper. Queried live (the OS setting can change).
  window.zgScrollBehavior = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  };

  // Reduced motion: autoplaying hero/producer loops stay paused on their
  // poster frame (CSS alone cannot stop a <video>). Script is deferred, so
  // every section video is in the DOM by the time this runs.
  if (ZG_REDUCE) {
    document.querySelectorAll('video[autoplay]').forEach((v) => {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }

  /* ── Shared money formatter ──
     Handles every Shopify money_format placeholder (amount,
     amount_no_decimals, *_with_comma_separator, *_with_apostrophe_separator)
     so client-side prices track the shop's real separators. Used by
     lux-cart.js and the gift-builder inline script. */
  window.zagaraFormatMoney = function (cents, format) {
    // Shops can wrap money_format in HTML (<span class="money">…</span>);
    // strip tags since callers assign the result via textContent.
    const fmt = String(format || window.moneyFormat || '${{amount}}').replace(/<\/?[^>]+>/g, '');
    function num(precision, thousands, decimal) {
      const parts = (Math.round(cents) / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, key) => {
      switch (key) {
        case 'amount_no_decimals':                      return num(0, ',', '.');
        case 'amount_with_comma_separator':             return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_apostrophe_separator':        return num(2, "'", '.');
        default:                                        return num(2, ',', '.');
      }
    });
  };

  function poll(check, cb, ms = 80, maxTries = 100, onFail) {
    let tries = 0;
    const id = setInterval(() => {
      if (check()) { clearInterval(id); cb(); }
      else if (++tries >= maxTries) { clearInterval(id); if (onFail) onFail(); }
    }, ms);
  }

  poll(
    () => typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined',
    () => {
      gsap.registerPlugin(ScrollTrigger);
      lib.gsap = true; lib.st = true;
      boot();
    },
    80, 100,   // give the CDN ~8s, then stop polling and boot degraded
    bootWithoutGsap
  );

  /* CDN never delivered GSAP: drop the intro/reveal animations but leave the
     page fully visible (complements the theme.liquid safety net, which also
     covers this case earlier but misses the class-based reveals). */
  function bootWithoutGsap() {
    if (window.__zgBooted) return;
    document.body.classList.remove('is-loading');
    const el = document.getElementById('loader');
    if (el) el.remove();
    document.querySelectorAll('.reveal-fade')
      .forEach(n => n.classList.add('is-revealed'));
  }

  /* ── Boot (animation features — needs GSAP; nav/header boot at the bottom
     of this file so they work even if the GSAP CDN never loads) ── */
  function boot() {
    // Tells the theme.liquid safety net that GSAP booted and owns reveals.
    window.__zgBooted = true;
    initLenis();
    initCursor();
    initReveal();
    initParallax();
  }

  /* ── Lenis ── */
  let lenis;
  function initLenis() {
    if (ZG_REDUCE) return;
    // native scrolling on touch devices: smoother and cheaper than synthetic smooth-scroll
    if (window.matchMedia('(pointer: coarse)').matches) return;
    // lazy: the script has no static tag — touch/reduced-motion visitors never
    // download it. Same-origin asset, so failure just leaves native scrolling.
    if (typeof Lenis !== 'undefined') { startLenis(); return; }
    var src = window.ZAGARA && window.ZAGARA.lenisSrc;
    if (!src) return;
    var s = document.createElement('script');
    s.src = src;
    s.onload = startLenis;
    document.head.appendChild(s);
  }
  function startLenis() {
    if (typeof Lenis === 'undefined' || lenis) return;
    lenis = new Lenis({
      duration: 1.45,
      easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothTouch: false,
      touchMultiplier: 1.4,
      /* Foglio 07 §2, correzioni del revisore (D3): la chat di Inbox vive negli shadow root aperti di <shopify-chat> (prima
         <inbox-online-store-chat>), dove data-lenis-prevent non si puo' mettere. Lenis guarda il percorso composto: senza
         questa riga la rotella sul suo elenco la prendeva lui (pagina +300, o niente a pannello aperto); con questa la lascia
         al browser, come per i contenitori [data-lenis-prevent]. */
      prevent: n => n.localName === 'shopify-chat' || n.localName === 'inbox-online-store-chat' ||
        /* il modulo «Notify me» dell'app STOQ (t3-notify-stoq, correzione del revisore): il velo e la finestra, i nomi della guida
           dell'app (help.stoqapp.com, dev mode). Senza, la rotella sopra il modulo scorreva la pagina dietro e non il modulo. */
        n.id === 'formContainer' || !!(n.classList && n.classList.contains('restock-rocket-wrapper')),
    });
    /* Giro finale, foglio 07 §2 (voce f07-rotella): l'istanza e' raggiungibile; la ferma e la riavvia zgScrollLock (piu'
       sotto). Lenis arriva tardi (dopo GSAP e lo script pigro): se un pannello ha gia' bloccato la pagina, nasce fermo.
       t2-unione-f07: vale anche per il menu del telefono gia' aperto (t2-telefono aveva una riga sua, su menu-is-open): il menu
       ora prende il blocco condiviso come gli altri pannelli, e il contatore lo conta. */
    window.ZAGARA = window.ZAGARA || {};
    window.ZAGARA.lenis = lenis;
    if (window.zgScrollLock && window.zgScrollLock.n > 0) lenis.stop();
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(t => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
  }

  /* ── Cursor ── UN CURSORE SOLO (giro finale, parte 1.2, 08/10/2026; le regole in luxury.css, «Cursor»).
     Il fiore si accende (html.zg-fiore) al primo pointermove di un MOUSE, gia' nel punto giusto (prima restava fermo a 0,0
     finche' il mouse non si muoveva), se vale la condizione del CSS: (hover: hover) and (pointer: fine) senza «riduci
     movimento», letta dal vivo. Si spegne al primo tocco o penna (pointerType: il tocco su un portatile o un iPad col
     trackpad generava eventi mouse di compatibilita' e il fiore saltava dove si toccava) e quando la condizione cambia;
     torna col primo movimento del mouse. Hover, campi e zone native per DELEGA (pointerover sul documento): valgono anche per
     quello che nasce dopo (carrello, risultati della ricerca, «Load more», preferiti), che prima non aveva gli ascoltatori. */
  function initCursor() {
    const cursor = document.getElementById('cursor');
    if (!cursor) return;
    const root = document.documentElement;
    const condizione = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');

    const logo = cursor.querySelector('.cursor__logo');
    const ring = cursor.querySelector('.cursor__ring');
    let mx = 0, my = 0, rx = 0, ry = 0;
    let running = false;   // rAF loop idles once the ring lerp converges
    let acceso = false;
    const logoR = 16, ringR = 24;   // half-size offsets for centering

    /* Quello che il fiore guarda sotto il puntatore. Un elemento disabilitato non lo fa ruotare. In fondo i tre DIV cliccabili a cui
       il tema da' cursor: pointer (inventario delle 81 regole con pointer, 08/10/2026: tutte le altre sono su controlli o figli di
       controlli): la riga dei preferiti, che apre il prodotto, e i veli della ricerca e del modale del paese, che chiudono. Con
       html.zg-fiore la manina non c'e' piu': un div cliccabile nuovo va qui, oppure porta data-hover. */
    const HOVER = 'a[href], button, summary, label, select, [role="button"], [role="link"], [role="tab"], [role="option"], ' +
      '[role="menuitem"], [role="checkbox"], [role="radio"], [role="switch"], [data-hover], ' +
      'input:is([type="checkbox"], [type="radio"], [type="submit"], [type="button"], [type="reset"], [type="image"], [type="file"], [type="color"], [type="range"]), ' +
      '.wl-item, .ls-overlay__scrim, .geo-modal__backdrop';
    /* Disabilitato: l'elemento, o la LABEL di un controllo disabilitato (le opzioni a zero del filtro del catalogo:
       lux-collection.js spegne l'input e mette aria-disabled, ma closest() trova la label, che di suo non e' mai :disabled). */
    const DIS = ':disabled, [aria-disabled="true"]';
    const spento = h => h.matches(DIS) || (h.tagName === 'LABEL' && !!h.control && h.control.matches(DIS));
    /* I campi di testo: lo stesso elenco della regola cursor: text di luxury.css. */
    const CAMPO = 'input:not([type="checkbox"], [type="radio"], [type="range"], [type="button"], [type="submit"], [type="reset"], ' +
      '[type="color"], [type="file"], [type="image"], [type="hidden"]), textarea, [contenteditable]:not([contenteditable="false"])';
    /* Le zone che disegnano il loro cursore: ogni iframe (un iframe di un'altra origine ferma i mousemove della pagina, il
       fiore resterebbe fermo sul bordo), la bolla di Inbox (shadow root con la sua manina, z-index sopra il fiore), hCaptcha. */
    const nativo = el => !!(el && el.nodeType === 1 &&
      (el.tagName === 'IFRAME' || el.closest('shopify-chat, #shop-hcaptcha-badge-container')));

    // One style write per element per frame: high-frequency mice fire
    // mousemove well above frame rate, so writes happen in loop(), not here.
    function loop() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      if (Math.abs(mx - rx) < 0.1 && Math.abs(my - ry) < 0.1) {
        rx = mx; ry = my;
        running = false;   // converged — paint the snap below, then idle
      }
      logo.style.transform = `translate(${mx - logoR}px,${my - logoR}px)`;
      ring.style.transform = `translate(${rx - ringR}px,${ry - ringR}px)`;
      if (running) requestAnimationFrame(loop);
    }

    let cursorVisible = true;   // la dissolvenza quando il puntatore esce dalla finestra
    const showCustomCursor = () => {
      if (cursorVisible) return;
      cursorVisible = true;
      gsap.to(cursor, { opacity: 1, duration: 0.18, overwrite: true });
    };
    const hideCustomCursor = duration => {
      if (!cursorVisible) return;
      cursorVisible = false;
      gsap.to(cursor, { opacity: 0, duration, overwrite: true });
    };

    function stato(t) {
      const el = t && t.nodeType === 1 ? t : null;
      const n = nativo(el);
      const h = !n && el ? el.closest(HOVER) : null;
      root.classList.toggle('zg-fiore-nativo', n);
      root.classList.toggle('zg-fiore-campo', !n && !!(el && el.closest(CAMPO)));
      root.classList.toggle('zg-fiore-hover', !!h && !spento(h));
    }
    function spegni() {
      if (!acceso) return;
      acceso = false;
      root.classList.remove('zg-fiore', 'zg-fiore-hover', 'zg-fiore-campo', 'zg-fiore-nativo');
    }

    document.addEventListener('pointermove', e => {
      if (e.pointerType !== 'mouse') { spegni(); return; }
      if (!condizione.matches) return;
      mx = e.clientX; my = e.clientY;
      if (!acceso) {
        acceso = true;
        rx = mx; ry = my;
        cursorVisible = true;
        gsap.set(cursor, { opacity: 1, overwrite: true });
        stato(e.target);
        root.classList.add('zg-fiore');
      } else if (root.classList.contains('zg-fiore-nativo') && !nativo(e.target)) {
        stato(e.target);   // di ritorno da un iframe: il primo movimento sulla pagina
      }
      if (!running) { running = true; requestAnimationFrame(loop); }
    }, { passive: true });
    document.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse') spegni();
    }, { passive: true, capture: true });
    document.addEventListener('pointerover', e => {
      if (!acceso || e.pointerType !== 'mouse') return;
      stato(e.target);
      showCustomCursor();
    }, { passive: true });
    const cambio = () => { if (!condizione.matches) spegni(); };
    if (condizione.addEventListener) condizione.addEventListener('change', cambio);
    else if (condizione.addListener) condizione.addListener(cambio);

    /* A cross-origin iframe (hCaptcha compreso) stops page mousemove events:
       hand it back to the native cursor without treating that transition as a
       full-window exit; normal page tracking resumes on the first
       pointerover/move back. */
    document.addEventListener('mouseout', e => {
      if (!acceso) return;
      const insideViewport = e.clientX > 0 && e.clientY > 0 &&
        e.clientX < window.innerWidth && e.clientY < window.innerHeight;
      const next = e.relatedTarget || (insideViewport ? document.elementFromPoint(e.clientX, e.clientY) : null);
      if (nativo(next)) {
        root.classList.add('zg-fiore-nativo');
        root.classList.remove('zg-fiore-hover', 'zg-fiore-campo');
        return;
      }
      if (e.relatedTarget || insideViewport) return;
      hideCustomCursor(0.3);
    });
  }

  /* ── Header ── */
  function initHeaderAutoHide() {
    const h = document.querySelector('.site-header');
    if (!h) return;

    // Filled background past 60px (was a ScrollTrigger at 'top -60'; plain JS
    // so the header works even when the GSAP CDN is blocked)
    // La soglia dalla mappa di theme.liquid (29/09/2026, decisione 2 del revisore): data-soglia-testata sul body; senza
    // l'attributo, 60 px come sempre (la home e le pagine piene non lo hanno). Le pagine senza immagine d'apertura hanno 0:
    // la testata e' trasparente solo a scorrimento 0 e si riempie al primo pixel.
    const zgSoglia = +(document.body.dataset.sogliaTestata || 60);
    const setFilled = y => h.classList.toggle('is-filled', y > zgSoglia);

    if (document.body.classList.contains('is-collection')) {
      document.body.classList.remove('header-hidden');
      // No auto-hide on collection pages, but the fill still tracks scroll
      const onScroll = () => setFilled(Math.max(window.scrollY || window.pageYOffset || 0, 0));
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      return;
    }

    const topLimit = 90;
    const deltaLimit = 8;
    let lastY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
    let ticking = false;

    const isPanelOpen = () => {
      if (document.body.classList.contains('menu-is-open')) return true;
      if (document.body.classList.contains('search-overlay-open')) return true;
      return !!document.querySelector(
        '[data-role="search-toggle"][aria-expanded="true"], ' +
        '[data-role="cart-toggle"][aria-expanded="true"], ' +
        '[data-role="wishlist-toggle"][aria-expanded="true"], ' +
        '.zg-nav-shop[aria-expanded="true"]'   // t2-menu: la tendina «Shop» aperta, come le tendine di carrello e preferiti
      );
    };

    const showHeader = () => document.body.classList.remove('header-hidden');
    const hideHeader = () => document.body.classList.add('header-hidden');

    // Voce 6 del registro (giro finale, tappa 2, decisione 8; mappa3 §7): dentro un palco agganciato del motore la testata, e
    // con lei la striscia che le sta dentro, resta nascosta in tutte e due le direzioni. Risalendo tornava e si dipingeva sopra
    // la prima riga del picco (trappola 62), anche a chi risaliva da sotto il palco con la testata gia' visibile. I palchi sono
    // quelli di window.__zpSc.acts (scrollcraft.js: pinned, top, height, aggiornati da layout()); sc-act--pinned la toglie
    // zg-scroll.js quando manda una rotaia in flusso. Senza motore (home, scheda, catalogo, ...) non cambia niente.
    const inPalco = (y) => {
      const api = window.__zpSc;
      if (!api || !api.acts || !api.acts.length) return false;
      const vh = window.innerHeight;
      return api.acts.some((a) => a.pinned && a.el && a.el.classList.contains('sc-act--pinned') &&
        y >= a.top - 1 && y <= a.top + a.height - vh + 1);
    };

    const update = () => {
      const y = Math.max(window.scrollY || window.pageYOffset || 0, 0);
      const delta = y - lastY;
      setFilled(y);

      if (y <= topLimit || isPanelOpen()) {
        showHeader();
        lastY = y;
      } else if (inPalco(y)) {
        hideHeader();
        lastY = y;
      } else if (Math.abs(delta) >= deltaLimit) {
        if (delta > 0) hideHeader();
        else showHeader();
        lastY = y;
      }

      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    document.addEventListener('click', requestUpdate, true);
    requestUpdate();
  }

  function initReveal() {
    const revealEls = document.querySelectorAll('.reveal-fade');

    if (window.Shopify && window.Shopify.designMode) {
      revealEls.forEach(el => el.classList.add('is-revealed'));
    } else {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -48px 0px' });
      revealEls.forEach(el => io.observe(el));
    }

    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll('.reveal-fade').forEach(el => el.classList.add('is-revealed'));
    });

    // Reduced motion: leave cards/panels/headings in their static CSS state
    if (ZG_REDUCE) return;

  }

  /* ── Parallax ── */
  function initParallax() {
    if (ZG_REDUCE) return;
    const img = document.querySelector('.parallax-media img');
    if (img) {
      gsap.to(img, {
        yPercent: 28,
        ease: 'none',
        scrollTrigger: { trigger: '.lux-parallax', start: 'top bottom', end: 'bottom top', scrub: true },
      });
    }

  }




  /* ── Input-modality tracker ──
     Programmatic focus restores (closing a drawer refocuses its toggle) make
     :focus-visible match even for pointer users, leaving a stray focus ring.
     html.zg-mouse marks pointer sessions so CSS can skip the ring; any key
     press (Tab, Escape, ...) removes it, keeping keyboard a11y intact. */
  document.addEventListener('pointerdown', function () {
    document.documentElement.classList.add('zg-mouse');
  }, true);
  document.addEventListener('keydown', function (e) {
    /* Only Tab signals keyboard navigation: Escape-closing a drawer or typing
       while mousing must not resurrect the focus ring on restored focus. */
    if (e.key === 'Tab') document.documentElement.classList.remove('zg-mouse');
  }, true);

  /* ── Il fuoco nelle file che scorrono di lato (giro finale, foglio 03 §2.17) ──
     Chrome non scorre una fila con overflow-x quando il fuoco va su un elemento
     che vi si affaccia solo in parte: al telefono la seconda scheda dei
     bestseller e dei prodotti suggeriti (in arabo tutta la seconda scheda)
     restava fuori per piu' di meta', anello compreso. Al focusin da tastiera
     (senza html.zg-mouse: col mouse e col dito non si sposta niente) il figlio
     della fila che contiene il fuoco, se non e' tutto dentro, si porta
     all'inizio della fila come l'aggancio (scroll-padding-inline-start),
     subito: dopo, il browser lo trova gia' dentro e non scorre lui. */
  document.addEventListener('focusin', function (e) {
    if (document.documentElement.classList.contains('zg-mouse')) return;
    var el = e.target;
    if (!el || el.nodeType !== 1) return;
    var fila = el.parentElement, cs = null;
    for (; fila && fila !== document.body; fila = fila.parentElement) {
      cs = getComputedStyle(fila);
      if ((cs.overflowX === 'auto' || cs.overflowX === 'scroll') && fila.scrollWidth > fila.clientWidth + 1) break;
    }
    if (!fila || fila === document.body) return;
    var pezzo = el;
    while (pezzo.parentElement && pezzo.parentElement !== fila) pezzo = pezzo.parentElement;
    var r = pezzo.getBoundingClientRect(), t = fila.getBoundingClientRect();
    var sx = t.left + fila.clientLeft, dx = sx + fila.clientWidth;
    var pi = parseFloat(cs.scrollPaddingInlineStart) || 0, pf = parseFloat(cs.scrollPaddingInlineEnd) || 0;
    var rtl = cs.direction === 'rtl';
    var lo = rtl ? sx + pf : sx + pi, hi = rtl ? dx - pi : dx - pf;
    if (r.left >= lo - 0.5 && r.right <= hi + 0.5) return;
    var dx2 = rtl ? r.right - hi : r.left - lo;
    /* 'instant' batte lo scroll-behavior: smooth delle file; un browser che non
       lo conosce lancia TypeError, e allora 'auto' */
    try { fila.scrollBy({ left: dx2, behavior: 'instant' }); } catch (err) { fila.scrollBy({ left: dx2, behavior: 'auto' }); }
  }, true);

  /* ── Shared focus trap for drawers/dialogs (Phase 6) ── */
  window.zgFocusTrap = (function () {
    let active = null;
    document.addEventListener('keydown', e => {
      if (e.key !== 'Tab' || !active) return;
      const els = Array.from(active.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(el => el.offsetParent !== null);
      if (!els.length) return;
      const first = els[0], last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    return {
      on(el) { active = el; },
      off(el) { if (!el || active === el) active = null; }
    };
  })();

  /* ── Shared refcounted scroll lock: overlays share the single inline
     body overflow property, so a plain set/clear is last-writer-wins —
     closing overlay B would unlock scroll behind still-open overlay A. ──
     Giro finale, foglio 07 §2 (voce f07-rotella): UN BLOCCO SOLO PER TUTTI I PANNELLI. Prima metteva solo overflow: hidden
     sul body, e Lenis (acceso al computer, initLenis) scorre la finestra da se' con scrollTo: a cassetto aperto la rotella
     sopra gli articoli faceva scorrere il catalogo dietro, e l'elenco si muoveva solo trascinando la barra.
     on()  al primo pannello: ricorda la posizione, overflow: hidden sul body (come prima), ferma Lenis (window.ZAGARA.lenis:
           da fermo annulla la rotella fuori dai contenitori [data-lenis-prevent] e dentro la lascia al browser, che scorre
           l'elenco; luxury.css da' a quei contenitori overscroll-behavior: contain) e attacca due guardie:
           - il dito: un touchmove che non fa scorrere un contenitore del pannello si annulla (Safari per iPhone, e al bordo
             dell'elenco dove overscroll-behavior non c'e', passerebbero la spinta alla pagina);
           - la tastiera: col fuoco dentro un pannello, frecce, Pagina su/giu', Inizio/Fine e lo spazio (fuori da bottoni,
             link e campi) scorrono il suo contenitore [data-lenis-prevent], anche col fuoco sulla X della testata (il
             browser scorrerebbe la pagina, che e' ferma).
     off() all'ultimo pannello chiuso (contatore): toglie tutto, riporta la pagina alla posizione di on() se qualcosa l'ha
           spostata (iOS che porta in vista un campo, per esempio) e riavvia Lenis, che riparte da li' (start() rilegge la
           posizione vera: nessun salto). Se il pannello si chiude mentre un dito e' giu' (i preferiti e il cassetto si chiudono
           al pointerdown fuori: il dito sul velo), la guardia del dito resta fino a quando il dito si alza: lo stesso gesto che
           chiude non fa scorrere la pagina (sul banco, prima: i preferiti a 390 px, un trascinamento sul velo chiudeva il
           foglio e spostava la pagina di 301 px). Il primo tocco nuovo a pagina sbloccata la toglie comunque.
     Dove Lenis non c'e' (tocco, «riduci movimento», GSAP che non arriva) vale tutto il resto. Un pannello nuovo: on() quando
     si apre, off() quando si chiude, data-lenis-prevent sul suo contenitore che scorre. */
  window.zgScrollLock = (function () {
    var lock = { n: 0, on: on, off: off };
    var y0 = 0, x0 = 0, tx = 0, ty = 0;
    var TASTI = { ArrowDown: 40, ArrowUp: -40, PageDown: 'p', PageUp: '-p', ' ': 'p', Home: 'inizio', End: 'fine' };
    var CAMPO = 'input, textarea, select, [contenteditable]:not([contenteditable="false"])';
    var PANNELLO = '[aria-modal="true"], [role="dialog"], .mobile-nav';
    function lenisDi() { return window.ZAGARA && window.ZAGARA.lenis; }
    function pos() { return { y: window.scrollY || window.pageYOffset || 0, x: window.scrollX || window.pageXOffset || 0 }; }
    /* el puo' ancora scorrere in quella direzione? dy > 0: verso il basso. In orizzontale basta che sborde. */
    function scorre(el, dx, dy) {
      var cs = getComputedStyle(el);
      if (Math.abs(dy) >= Math.abs(dx)) {
        if (!/(auto|scroll)/.test(cs.overflowY) || el.scrollHeight <= el.clientHeight + 1) return false;
        if (!dy) return true;
        return dy > 0 ? el.scrollTop + el.clientHeight < el.scrollHeight - 1 : el.scrollTop > 0;
      }
      return /(auto|scroll)/.test(cs.overflowX) && el.scrollWidth > el.clientWidth + 1;
    }
    var giu = false;   // un dito o una penna sono giu': lo dice pointerdown in cattura, prima dei gestori che chiudono al tocco fuori
    function premuto(e) {
      if (!lock.n) { staccaDito(); return; }   // gesto nuovo a pagina sbloccata: la guardia rimasta dal gesto che ha chiuso se ne va
      if (e.pointerType && e.pointerType !== 'mouse') giu = true;
    }
    function inizioDito(e) {
      /* pointerdown viene prima di touchstart: nel gesto che chiude, qui la pagina e' gia' sbloccata ma giu' e' vero. Senza
         pointer events (Safari prima della 13) giu' e' falso: gesto nuovo, la guardia se ne va. */
      if (!lock.n && !giu) { staccaDito(); return; }
      if (e.touches.length === 1) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }
    }
    function fineDito(e) { if (e.touches && e.touches.length) return; giu = false; if (!lock.n) staccaDito(); }
    function attaccaDito() {
      document.addEventListener('pointerdown', premuto, true);
      document.addEventListener('touchstart', inizioDito, { passive: true });
      document.addEventListener('touchmove', dito, { passive: false });
      document.addEventListener('touchend', fineDito, true);
      document.addEventListener('touchcancel', fineDito, true);
    }
    function staccaDito() {
      giu = false;
      document.removeEventListener('pointerdown', premuto, true);
      document.removeEventListener('touchstart', inizioDito, { passive: true });
      document.removeEventListener('touchmove', dito, { passive: false });
      document.removeEventListener('touchend', fineDito, true);
      document.removeEventListener('touchcancel', fineDito, true);
    }
    function dito(e) {
      if (e.touches.length !== 1) return;   // due dita: lo zoom resta del browser
      var t = e.touches[0], dx = tx - t.clientX, dy = ty - t.clientY;
      tx = t.clientX; ty = t.clientY;
      /* Correzioni del revisore (D3): il percorso composto, che entra negli shadow root aperti (la chat di Inbox). Risalendo
         da e.target il documento vedeva solo l'ospite <shopify-chat>: a pannello aperto il suo elenco non scorreva col dito. */
      var via = e.composedPath ? e.composedPath() : [];
      if (!via.length) for (var q = e.target; q; q = q.parentElement) via.push(q);
      for (var i = 0; i < via.length; i++) {
        var el = via[i];
        if (!el || el === document.body || el === document.documentElement || el === document || el === window) break;
        if (el.nodeType !== 1) continue;   // i ShadowRoot nel percorso
        if (scorre(el, dx, dy)) return;
      }
      if (e.cancelable) e.preventDefault();
    }
    function tastiera(e) {
      var passo = TASTI[e.key];
      if (!passo || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
      var t = e.target;
      if (!t || t.nodeType !== 1 || t.closest(CAMPO)) return;
      if (e.key === ' ' && t.closest('a[href], button, summary, label, [role="button"], [role="link"], [role="menuitem"], [role="checkbox"], [role="radio"], [role="switch"], [role="tab"], [role="option"]')) return;
      var s = t.closest('[data-lenis-prevent]');
      if (!s || !scorre(s, 0, 0)) {
        var p = t.closest(PANNELLO);
        s = null;
        if (p) {
          var tutti = [p].concat(Array.prototype.slice.call(p.querySelectorAll('[data-lenis-prevent]')));
          for (var i = 0; i < tutti.length; i++) {
            if ((tutti[i] === p ? p.hasAttribute('data-lenis-prevent') : true) && scorre(tutti[i], 0, 0)) { s = tutti[i]; break; }
          }
        }
      }
      if (!s) return;
      e.preventDefault();
      var pagina = Math.max(40, s.clientHeight * 0.875), su = e.shiftKey && e.key === ' ';
      var opz = { behavior: window.zgScrollBehavior ? window.zgScrollBehavior() : 'auto' };
      if (passo === 'inizio') { opz.top = 0; s.scrollTo(opz); return; }
      if (passo === 'fine') { opz.top = s.scrollHeight; s.scrollTo(opz); return; }
      opz.top = passo === 'p' ? (su ? -pagina : pagina) : passo === '-p' ? -pagina : passo;
      s.scrollBy(opz);
    }
    function on() {
      if (lock.n++) return;
      var p = pos(); y0 = p.y; x0 = p.x;
      document.body.style.overflow = 'hidden';
      var l = lenisDi(); if (l) l.stop();
      attaccaDito();
      document.addEventListener('keydown', tastiera);
    }
    function off() {
      if (lock.n <= 0 || --lock.n) return;
      if (!giu) staccaDito();   // col dito ancora giu' la guardia resta fino a fineDito (qui sopra)
      document.removeEventListener('keydown', tastiera);
      document.body.style.overflow = '';
      var p = pos();
      if (Math.abs(p.y - y0) > 0.5 || Math.abs(p.x - x0) > 0.5) {
        /* 'instant' batte lo scroll-behavior: smooth che alcune pagine danno a html; un browser che non lo conosce lancia */
        try { window.scrollTo({ top: y0, left: x0, behavior: 'instant' }); } catch (err) { window.scrollTo(x0, y0); }
      }
      var l = lenisDi(); if (l) l.start();
    }
    return lock;
  })();

  /* ── La testata del telefono: UNA media query per il menu del telefono e la tendina «Shop» (giro finale, tappa 2, voce
     t2-unione-f07). Dalla voce t2-soglia e' window.ZAGARA.testataTelefono (primo blocco di questo file, 1151.98 px, la stessa
     di carrello e preferiti; prima qui c'era la soglia del CSS di allora, 767.98). Passandola, il pannello che non si vede piu'
     si chiude (il menu allargando, la tendina stringendo) e toglie il blocco condiviso: altrimenti la pagina restava ferma fino
     a un clic. ── */
  const testataTelefono = window.ZAGARA.testataTelefono;
  const allaSoglia = fn => {
    if (testataTelefono.addEventListener) testataTelefono.addEventListener('change', fn);
    else if (testataTelefono.addListener) testataTelefono.addListener(fn);
  };

  /* ── Mobile Menu ──
     Giro finale, tappa 2, voce t2-telefono (decisione 9; mappa3 §5.4): aperto e chiuso passano tutti da imposta().
     - aprendo: il fuoco va alla prima riga del pannello (la lingua; senza lingue la prima voce), senza far scorrere niente;
       la pagina si blocca col blocco condiviso (zgScrollLock, qui sopra: ferma anche Lenis, acceso al computer): il
       pannello ha data-lenis-prevent e scorre da se', la pagina dietro no;
     - Tab gira fra il bottone del menu e il pannello, nei due sensi (prima usciva verso le altre icone e la pagina sotto);
       se il fuoco e' altrove (in un'altra finestra aperta sopra) il Tab non e' nostro;
     - Esc chiude e torna al bottone; il clic fuori e il bottone chiudono, e il fuoco rimasto nel pannello torna al bottone
       (Safari non da' il fuoco ai bottoni cliccati: restava su una riga nascosta); una voce cliccata chiude e basta (la
       pagina cambia, o la ricerca prende il fuoco);
     - chiudendo, l'elenco delle lingue aperto si chiude e il blocco si toglie (Lenis riparte, se nessun altro pannello e'
       aperto);
     - la finestra che si allarga oltre la soglia del telefono chiude il pannello (sopra il pannello sparisce, e la pagina
       restava bloccata). La soglia e' window.ZAGARA.testataTelefono, 1151.98 dalla voce t2-soglia (prima 767.98).
     Voce menu-shop (foglio di Giacomo del 12/10, classe 2): «Shop» e' un <button> a tendina (data-shop-toggle, aria-expanded
     e aria-controls = il contenitore delle cinque voci): il tocco lo apre e lo chiude, Invio e Spazio sono il clic del
     bottone, niente naviga («All products» e' la prima sotto-voce). Chiusa OGNI volta che il pannello si apre, di colpo e
     prima di cercare la prima riga del fuoco (le voci chiuse sono visibility: hidden e non contano per il Tab): la classe
     mobile-nav--azzera spegne per un fotogramma le transizioni (luxury.css). Chiudendo il pannello l'elenco resta com'e':
     sparisce con lui. Il Tab gira fra le righe visibili (righe()): chiusa, le cinque voci non ci sono; aperta, dopo «Shop»
     viene «All products». Vale anche in italiano e in spagnolo fino a 1279.98 px: e' lo stesso pannello.
     Unione col ramo zg-f07 (voce t2-unione-f07): il blocco e' quello di f07-rotella (prima del foglio 07 qui c'erano
     lenis.stop()/start(), piu' body.menu-is-open { overflow: hidden }, che resta in luxury.css come rete). La chiusura al
     passaggio della finestra e' UNA: questa, su testataTelefono (qui sopra); quella di f07-rotella (D1: un
     resize che chiude quando .mobile-nav non si vede) non c'e' piu', e il suo caso (menu aperto a 700, finestra a 1512) lo
     chiude questa. bloccato tiene on/off in pari. */
  function initMobileMenu() {
    const btn = document.querySelector('[data-menu-toggle]');
    if (!btn) return;
    const nav = document.getElementById(btn.getAttribute('aria-controls') || '') || document.querySelector('[data-mobile-menu]');
    const aperto = () => document.body.classList.contains('menu-is-open');
    const FUOCO = 'a[href], button:not([disabled]), summary, input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
    // una riga conta se si vede, e non dentro un <details> chiuso fuori dal suo <summary> (l'elenco delle lingue): li' Chrome
    // da' comunque un rettangolo (il contenuto chiuso e' solo «saltato») e focus() non fa niente, e il Tab restava fermo
    const chiusa = el => { const d = el.closest('details:not([open])'); const s = el.closest('summary'); return !!d && !(s && s.parentElement === d); };
    const righe = () => (nav ? Array.prototype.filter.call(nav.querySelectorAll(FUOCO), el =>
      el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[inert]') && !chiusa(el) &&
      (typeof el.checkVisibility !== 'function' || el.checkVisibility({ visibilityProperty: true }))) : []);
    let bloccato = false;
    // «Shop» a tendina (voce menu-shop): il bottone e il suo contenitore, se il pannello li ha
    const shop = nav && nav.querySelector('[data-shop-toggle]');
    const shopImposta = (apri, subito) => {
      if (!shop) return;
      if (subito) nav.classList.add('mobile-nav--azzera');
      shop.setAttribute('aria-expanded', String(apri));
      if (subito) { void nav.offsetHeight; nav.classList.remove('mobile-nav--azzera'); }
    };
    // ritocco del 12/10: senza script il bottone non fa niente e nasce fuori dal Tab (tabindex="-1" in lux-header.liquid); qui funziona e ci rientra
    if (shop) { shop.removeAttribute('tabindex'); shop.addEventListener('click', () => shopImposta(shop.getAttribute('aria-expanded') !== 'true', false)); }
    // fuoco: 'bottone' (Esc), 'se-dentro' (torna al bottone solo se era nel pannello), 'no'
    const imposta = (open, fuoco) => {
      if (open === aperto()) return;
      document.body.classList.toggle('menu-is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      if (open !== bloccato) { bloccato = open; if (open) zgScrollLock.on(); else zgScrollLock.off(); }
      if (open) {
        shopImposta(false, true);
        const prima = righe()[0];
        if (prima) prima.focus({ preventScroll: true });
        return;
      }
      if (nav) nav.querySelectorAll('details[open]').forEach(d => { d.open = false; });
      const dentro = nav && nav.contains(document.activeElement);
      if (fuoco === 'bottone' || (fuoco === 'se-dentro' && dentro)) btn.focus({ preventScroll: true });
    };
    btn.addEventListener('click', () => imposta(!aperto(), 'se-dentro'));
    document.querySelectorAll('.mobile-nav a').forEach(a => a.addEventListener('click', () => imposta(false, 'no')));
    // Dropdown panel: tapping the visible page below it closes the menu
    document.addEventListener('click', e => {
      if (!aperto()) return;
      if (e.target.closest('.mobile-nav, [data-menu-toggle], .site-header')) return;
      imposta(false, 'se-dentro');
    });
    // Keyboard parity with the other overlays: ESC closes and refocuses the toggle
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || !aperto()) return;
      imposta(false, 'bottone');
    });
    // Tab chiuso nel pannello: il bottone del menu e le righe visibili del pannello, in giro
    document.addEventListener('keydown', e => {
      if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey || !aperto()) return;
      const giro = [btn].concat(righe());
      if (giro.length < 2) return;
      const a = document.activeElement;
      const i = giro.indexOf(a);
      if (i < 0 && a && a !== document.body && !(nav && nav.contains(a))) return;
      e.preventDefault();
      const n = giro.length;
      giro[i < 0 ? (e.shiftKey ? n - 1 : 1) : (i + (e.shiftKey ? n - 1 : 1)) % n].focus();
    });
    // il fuoco rimasto nel pannello o sul suo bottone (sopra la soglia spariscono tutti e due) va alla prima voce della barra, come
    // il carrello e i preferiti lo riportano all'icona che si vede (revisione di t2-soglia, difetto 2): senza, finiva sul body e il
    // Tab saltava la testata. Il bottone anche a menu chiuso: e' la stessa porta del menu (correzioni di t2-soglia).
    // perso: Chrome toglie il fuoco a un elemento che il CSS nasconde (blur e focusout verso nessuno) e a volte lo fa PRIMA del
    // «change» della soglia (banco: 1 volta su 40), quando activeElement e' gia' il body. Si segna solo se l'elemento non si
    // vede piu' e la finestra e' gia' sopra la soglia, cioe' quando a nasconderlo e' stata la soglia; un altro fuoco lo azzera.
    let perso = false;
    const segna = e => { perso = !e.relatedTarget && !testataTelefono.matches && !e.target.getClientRects().length; };
    btn.addEventListener('focusout', segna);
    if (nav) nav.addEventListener('focusout', segna);
    document.addEventListener('focusin', () => { perso = false; });
    allaSoglia(() => {
      if (testataTelefono.matches) return;
      const a = document.activeElement;
      const dentro = perso || (!!a && (a === btn || (!!nav && nav.contains(a))));
      perso = false;
      imposta(false, 'no');
      const v = dentro && document.querySelector('.header-inner--d :is(.header-nav > a, .zg-nav-voce > a)');
      if (v) v.focus({ preventScroll: true });
    });
  }

  /* ── La tendina «Shop» (snippets/zg-categorie-shop.liquid; giro finale, tappa 2, voce t2-menu, 09/10/2026; foglio 02 §3,
     mappa3 §3.3) ── Lo schema «disclosure» dell'APG: aria-expanded e aria-controls sul link «Shop», niente role="menu".
     - mouse: apre al primo movimento sopra la voce, non al solo ingresso (correzioni di t2-unione-f07: piu' giu', accanto a
       pointerenter), uscendo chiude dopo 200 ms (ci si arriva in diagonale); il clic segue il link;
     - tocco o penna (l'ultimo pointerdown sul link): il primo tocco apre, il secondo segue il link;
     - tastiera su «Shop»: Invio o Spazio a tendina chiusa aprono e il fuoco resta li'; Invio a tendina aperta segue il link,
       Spazio la chiude; Freccia giu' apre e porta il fuoco alla prima voce. Nelle voci Freccia giu'/su, Inizio e Fine
       spostano il fuoco (su dalla prima torna a «Shop»);
     - Invio o clic con Cmd, Ctrl, Maiusc o Alt non aprono: il browser apre il catalogo in un'altra scheda o finestra, come
       prima della tendina (correzioni di t2-menu, 09/10/2026);
     - l'attivazione senza puntatore a tendina chiusa (un click con detail 0 senza pointerdown: l'azione predefinita di
       VoiceOver, VO+Spazio, e di NVDA o JAWS in modalita' lettura, che non mandano il keydown) apre come Invio, il secondo
       segue il link; prima seguiva subito il link e le 5 voci non entravano mai nell'albero (correzioni di t2-menu);
     - Esc chiude e, se il fuoco era dentro, lo riporta su «Shop»; chiude anche la tendina aperta dal mouse col fuoco altrove
       (WCAG 1.4.13);
     - il fuoco che esce verso un altro elemento (Tab) e il clic o il tocco fuori chiudono (anche al pointerdown: Safari su
       iPad non manda il click al documento da un punto che non e' un link o un bottone).
     L'uscita del mouse chiude solo la tendina aperta dal mouse; un tasto premuto dentro la tendina aperta la fa «della
     tastiera», cosi' il fuoco non resta su una voce nascosta. Chiusa, la lista e' inert subito: mentre sfuma (.16 s, luxury.css)
     le voci non prendono il fuoco (Shift+Tab subito dopo la chiusura), il tocco ne' il puntatore. .zg-nav-voce--js spegne il
     ripiego CSS (:hover e :focus-within, luxury.css): senza questo script la tendina si apre ancora.
     Unione col foglio 07 (voce t2-unione-f07; foglio 07 §2, f07-rotella): aperta, la tendina prende il blocco condiviso
     (zgScrollLock: ferma Lenis, overflow: hidden sul body, le guardie del dito e della tastiera), come le tendine del carrello
     e dei preferiti; chiusa, lo lascia. bloccata tiene on/off in pari. Non scorre (cinque voci, nessun max-height): niente
     data-lenis-prevent, la rotella sopra di lei non muove niente. Passando nella testata del telefono (testataTelefono, la
     finestra che si stringe) si chiude: la barra sparisce, e la tendina aperta teneva la pagina ferma e la testata scoperta
     (D5 della revisione di t2-menu, che col blocco sarebbe diventato una pagina che non scorre fino a un clic). */
  function initTendina() {
    document.querySelectorAll('[data-zg-tendina]').forEach(voce => {
      const shop = voce.querySelector(':scope > a'), lista = voce.querySelector('.zg-tendina');
      if (!shop || !lista) return;
      let da = '', timer = 0, puntatore = 'mouse', bloccata = false, entrato = false;
      const aperta = () => voce.classList.contains('is-open');
      const blocca = v => { if (v !== bloccata && window.zgScrollLock) { bloccata = v; if (v) zgScrollLock.on(); else zgScrollLock.off(); } };
      const apri = come => { clearTimeout(timer); da = come; voce.classList.add('is-open'); lista.inert = false; shop.setAttribute('aria-expanded', 'true'); blocca(true); };
      const chiudi = rifuoca => {
        clearTimeout(timer);
        if (!aperta()) return;
        voce.classList.remove('is-open');
        lista.inert = true;
        shop.setAttribute('aria-expanded', 'false');
        blocca(false);
        if (rifuoca) shop.focus();
      };
      voce.classList.add('zg-nav-voce--js');
      lista.inert = true;
      shop.setAttribute('aria-expanded', 'false');
      /* il mouse apre quando si MUOVE su «Shop»: pointerenter arriva anche quando e' la testata a tornare sotto il puntatore
         fermo (risalendo: Chrome manda pointerover e pointerenter, nessun pointermove), e la tendina aperta ferma la pagina */
      voce.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { clearTimeout(timer); entrato = true; } });
      voce.addEventListener('pointermove', e => { if (e.pointerType === 'mouse' && entrato) { entrato = false; if (!aperta()) apri('mouse'); } });
      voce.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') { entrato = false; if (da === 'mouse') timer = setTimeout(() => chiudi(false), 200); } });
      shop.addEventListener('pointerdown', e => { puntatore = e.pointerType || 'mouse'; });
      const conTasti = e => e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
      shop.addEventListener('click', e => {
        if (aperta() || conTasti(e)) return;
        if (puntatore !== 'mouse' || e.detail === 0) { e.preventDefault(); apri(puntatore !== 'mouse' ? 'tocco' : 'tastiera'); }
      });
      voce.addEventListener('keydown', e => {
        if (aperta()) da = 'tastiera';
        const voci = Array.from(lista.querySelectorAll('a')), i = voci.indexOf(e.target);
        if (e.target === shop) {
          if (e.key === ' ' || (e.key === 'Enter' && !aperta() && !conTasti(e))) { e.preventDefault(); if (aperta()) chiudi(false); else apri('tastiera'); }
          else if (e.key === 'ArrowDown' && voci.length) { e.preventDefault(); apri('tastiera'); voci[0].focus(); }
        } else if (i >= 0 && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(e.key)) {
          e.preventDefault();
          const n = voci.length - 1;
          const j = e.key === 'Home' ? 0 : e.key === 'End' ? n : e.key === 'ArrowDown' ? Math.min(i + 1, n) : i - 1;
          (j < 0 ? shop : voci[j]).focus();
        }
      });
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && aperta()) chiudi(voce.contains(document.activeElement)); });
      voce.addEventListener('focusout', e => { if (aperta() && e.relatedTarget && !voce.contains(e.relatedTarget)) chiudi(false); });
      const fuori = e => { if (aperta() && !voce.contains(e.target)) chiudi(false); };
      document.addEventListener('pointerdown', fuori);
      document.addEventListener('click', fuori);
      // il fuoco rimasto nella tendina o su «Shop», aperta o chiusa (sotto la soglia la barra sparisce), va al bottone del menu del
      // telefono (revisione di t2-soglia, difetto 2; «Shop» chiusa: correzioni di t2-soglia). perso: come nel menu del telefono,
      // il fuoco che Chrome toglie prima del «change» (l'elemento non si vede piu' e la finestra e' gia' sotto la soglia)
      let perso = false;
      voce.addEventListener('focusout', e => { perso = !e.relatedTarget && testataTelefono.matches && !e.target.getClientRects().length; });
      document.addEventListener('focusin', () => { perso = false; });
      allaSoglia(() => {
        if (!testataTelefono.matches) return;
        const dentro = perso || voce.contains(document.activeElement);
        perso = false;
        chiudi(false);
        const m = dentro && document.querySelector('.header-inner--m [data-menu-toggle]');
        if (m) m.focus({ preventScroll: true });
      });
      if (voce.matches(':hover')) entrato = true;
      /* lasciando la pagina (anche verso la cache avanti-indietro) la tendina si chiude: tornando con Indietro non resta aperta
         col blocco (aperta con la tastiera o al tocco nessun puntatore la richiude) */
      window.addEventListener('pagehide', () => chiudi(false));
    });
  }

  /* ── Le lingue (snippets/zg-lingue.liquid; giro finale, tappa 2, voce t2-lingue, 09/10/2026) ──
     Il selettore e' un <details>: Invio e Spazio sul bottone lo aprono e lo chiudono da soli. Qui le tre chiusure che
     <details> non ha:
     - Esc, in cattura sul documento: chiude l'elenco aperto; se il fuoco era dentro o da nessuna parte lo riporta sul bottone e
       l'Esc non va oltre (a pannello del telefono aperto il primo Esc chiude solo l'elenco, il secondo il pannello). Col fuoco
       altrove l'Esc va avanti (revisione di t2-lingue, difetto 3: Safari lascia l'elenco aperto senza fuoco, e una finestra
       aperta senza clic, come quella di benvenuto, perdeva il primo Esc);
     - il clic o il tocco fuori dall'elenco;
     - il fuoco che esce col Tab, solo verso un altro elemento (relatedTarget): Safari non da' il fuoco ai bottoni
       cliccati, e chiudere al fuoco «perso» chiuderebbe l'elenco prima che il clic arrivi alla lingua. */
  function initLingue() {
    const tutti = Array.prototype.slice.call(document.querySelectorAll('details[data-zg-lingue]'));
    if (!tutti.length) return;
    const chiudi = (d, rifuoca) => {
      d.open = false;
      if (rifuoca) { const s = d.querySelector('summary'); if (s) s.focus(); }
    };
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      const aperto = tutti.find(d => d.open);
      if (!aperto) return;
      const f = document.activeElement;
      const qui = !f || f === document.body || aperto.contains(f);
      chiudi(aperto, qui);
      if (qui) e.stopPropagation();
    }, true);
    document.addEventListener('click', e => {
      tutti.forEach(d => { if (d.open && !d.contains(e.target)) chiudi(d, false); });
    });
    tutti.forEach(d => d.addEventListener('focusout', e => {
      if (d.open && e.relatedTarget && !d.contains(e.relatedTarget)) chiudi(d, false);
    }));
  }

  /* ── Add-to-cart failure feedback ──
     Inline role=alert line under the button (same .col-card__atc-error
     pattern as the search grid / product form). Shared via window.zgAtcError
     with the quick-view and featured/bestseller handlers. */
  function showAtcError(btn, err) {
    const host = btn.closest('.col-card__info');
    let el;
    if (host) {
      el = host.querySelector('.col-card__atc-error');
    } else {
      el = btn.nextElementSibling && btn.nextElementSibling.classList.contains('col-card__atc-error')
        ? btn.nextElementSibling : null;
    }
    if (!el) {
      el = document.createElement('p');
      el.className = 'col-card__atc-error';
      el.setAttribute('role', 'alert');
      if (host) host.appendChild(el);
      else btn.insertAdjacentElement('afterend', el);
    }
    el.textContent = (err && err.userMessage) ||
      ((window.ZAGARA && ZAGARA.i18n && ZAGARA.i18n.cartError) || 'Something went wrong — please try again.');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.remove(), 4000);
  }
  window.zgAtcError = showAtcError;

  /* ── Quick Add to Cart ──
     Delegated handler for [data-add-to-cart] buttons (product cards) on ANY
     page — homepage, producer pages, collections. Registered outside boot()
     so it works even if GSAP never loads. */
  function initQuickAdd() {
    if (window.__zgQuickAddBound) return;   // never double-bind (would double-add)
    window.__zgQuickAddBound = true;

    document.addEventListener('click', async e => {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      // The product page puts data-add-to-cart on its <form>; that submit
      // flow is owned by lux-cart.js — only quick-add buttons belong here.
      if (btn.tagName === 'FORM') return;
      e.preventDefault();
      if (btn.disabled) return;

      const id = btn.dataset.addToCart;
      const textEl = btn.querySelector('.col-card__add-text');
      const checkEl = btn.querySelector('.col-card__add-check');

      btn.disabled = true;
      btn.classList.add('col-card__quick-add--loading');

      try {
        /* Parte B del foglio «Due lavori in sequenza», punto 2: la strada dell'aggiunta dalla scheda (lux-cart.js, apiAdd):
           add.js col carrello nella stessa risposta (secondo giro), un disegno. Prima qui: add + due /cart.js (openCartDrawer e
           updateCartCount), e due disegni. Senza lux-cart.js, il ripiego qui sotto. */
        const cartApi = window.zagaraCart && window.zagaraCart.add ? window.zagaraCart : null;
        if (cartApi) {
          await new Promise((ok, ko) => cartApi.add(id, 1, ok, ko));
        } else {
          /* ripiego: add.js (JSON), non routes.cart_add («/cart/add», che risponde con tutta la pagina /cart); routes.root in arabo e' «/ar» */
          const radice = ((window.routes && window.routes.root) || '/').replace(/\/?$/, '/');
          const res = await fetch(radice + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id, quantity: 1 }),
          });
          if (!res.ok) {
            const body = await res.json().catch(() => ({}));
            const err = new Error('HTTP ' + res.status);
            err.userMessage = body.description || body.message || '';
            throw err;
          }
        }

        btn.classList.remove('col-card__quick-add--loading');
        btn.classList.add('col-card__quick-add--done');
        if (textEl) textEl.style.opacity = '0';
        if (checkEl && window.gsap) gsap.from(checkEl, { scale: 0, duration: 0.45, ease: 'back.out(2.5)' });

        // Open cart drawer + refresh (con lux-cart.js il carrello e' gia' quello della risposta: si apre e basta)
        if (cartApi) cartApi.open(null);
        else {
          window.openCartDrawer && window.openCartDrawer();
          if (typeof window.updateCartCount === 'function') window.updateCartCount();
        }

        setTimeout(() => {
          btn.classList.remove('col-card__quick-add--done');
          btn.disabled = false;
          if (textEl) textEl.style.opacity = '';
        }, 2400);

      } catch (err) {
        btn.classList.remove('col-card__quick-add--loading');
        btn.disabled = false;
        showAtcError(btn, err);
      }
    });
  }

  /* ── Natale (foglio di Giacomo del 17/10/2026, ritocchi del 18/10): la testata scrive la configurazione
     (#zg-natale-conf) e decide prima del primo disegno (sections/lux-header.liquid, dove c'e' tutta la
     spiegazione): se e' Natale mette html.zg-natale. Qui solo il caricamento: zg-natale.js dopo il load, nel
     primo momento libero: LCP e INP non lo vedono. Senza la classe non si scarica niente. ── */
  function initNatale() {
    var el = document.getElementById('zg-natale-conf'), c;
    if (!el) return;
    try { c = JSON.parse(el.textContent); } catch (e) { return; }
    if (!c || !c.src) return;
    /* ritocco del 18/10: la decisione (data a Brisbane, ?natale=1 ricordato nella scheda, ?natale=0) la prende il codice dell'intestazione
       prima del primo disegno (sections/lux-header.liquid) e la scrive come classe su <html>: qui si legge e basta */
    if (!document.documentElement.classList.contains('zg-natale')) return;
    function carica() { var s = document.createElement('script'); s.src = c.src; s.async = true; document.head.appendChild(s); }
    function dopo() { if (window.requestIdleCallback) window.requestIdleCallback(carica, { timeout: 4000 }); else setTimeout(carica, 200); }
    if (document.readyState === 'complete') dopo(); else window.addEventListener('load', dopo, { once: true });
  }

  /* ── GSAP-free boot: navigation, header and quick-add must work even when
     the CDN (gsap/ScrollTrigger) is blocked — only animations may degrade.
     The script is deferred, so the DOM is already parsed here. ── */
  initHeaderAutoHide();
  initMobileMenu();
  initTendina();
  initLingue();
  initQuickAdd();
  try { initNatale(); } catch (e) { }

})();
